"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_CommandingPresenceEffectHandler = exports.Passive_CommandingPresenceEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class Passive_CommandingPresenceEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Passive_CommandingPresence;
        this.__typeName = "Passive_CommandingPresence";
        this.name = "Commanding Presence";
        this.harmful = false;
    }
}
exports.Passive_CommandingPresenceEffectArgs = Passive_CommandingPresenceEffectArgs;
let Passive_CommandingPresenceEffectHandler = class Passive_CommandingPresenceEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const ally of container.selectTargets(state.creatorId, Target_1.Target.AllAllies)) {
            container.applyBuff({
                sequence,
                creatorId: state.creatorId,
                targetId: ally,
                effect: new _1.CommandingPresenceEffectArgs(),
                duration: Duration_1.Duration.Permanent,
            });
        }
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.AttributeChanged, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_CommandingPresence_OnHealthChange", {}));
        state.meta.onAllyResurrectedId = container.registerEventHandlerScript(state.creatorId, EventType_1.EventType.AllyResurrected, Schedule_1.Schedule.Unlimited, "Effect_CommandingPresence_OnAllyResurrected", {});
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        container.cancelEventHandler(state.meta.eventHandlerId);
        container.cancelEventHandler(state.meta.onAllyResurrectedId);
        for (const ally of container.selectTargets(state.creatorId, Target_1.Target.AllAllies)) {
            for (const effectId of container.getEffectsOfType(ally, EffectType_1.EffectType.CommandingPresence)) {
                const effect = container.getEffect(effectId);
                if (effect.creatorId !== state.creatorId) {
                    continue;
                }
                container.cancelEffect(sequence, effect.creatorId);
            }
        }
    }
};
Passive_CommandingPresenceEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_CommandingPresence)
], Passive_CommandingPresenceEffectHandler);
exports.Passive_CommandingPresenceEffectHandler = Passive_CommandingPresenceEffectHandler;
